var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"hidden-sm-and-down",attrs:{"cols":"12","md":"6","lg":"7"}},[_c('v-img',{attrs:{"aspect-ratio":"1","src":require("@/assets/sigefLogin.png")}})],1),_c('v-col',{attrs:{"cols":"12","md":"6","lg":"5"}},[_c('v-main',[_c('RouterView')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }